// @ts-check
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { CHAT_STATUS_MAP } from 'constants/index';

const ChatStatusIndicator = ({ classes, status }) => {
  if (![CHAT_STATUS_MAP.AVAILABLE, CHAT_STATUS_MAP.UNAVAILABLE].includes(status)) {
    return null;
  }

  const classnames = cx(
    classes.dot,
    {
      [classes.available]: status === CHAT_STATUS_MAP.AVAILABLE,
      [classes.unavailable]: status === CHAT_STATUS_MAP.UNAVAILABLE,
    },
    classes.root,
  );

  return <span className={classnames} />;
};

ChatStatusIndicator.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  status: PropTypes.bool,
};

ChatStatusIndicator.defaultProps = {
  classes: {},
};

export default ChatStatusIndicator;
